export default __webpack_public_path__ + "static/media/todoDesktop.b2dc38ea.jpg";